module.exports = __webpack_public_path__ + "static/media/Podcast_Ep_Munoz.938dd33.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/podcast/Podcast_Ep_Munoz.mp3
// module id = 1luU
// module chunks = 0